import { render, staticRenderFns } from "./audioMain.vue?vue&type=template&id=66f23a14&scoped=true&"
import script from "./audioMain.vue?vue&type=script&lang=js&"
export * from "./audioMain.vue?vue&type=script&lang=js&"
import style0 from "./audioMain.vue?vue&type=style&index=0&id=66f23a14&prod&lang=scss&"
import style1 from "./audioMain.vue?vue&type=style&index=1&id=66f23a14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f23a14",
  null
  
)

export default component.exports